import { render, staticRenderFns } from "./AssociadoProfile.vue?vue&type=template&id=0f46cdc7"
import script from "./AssociadoProfile.vue?vue&type=script&lang=js"
export * from "./AssociadoProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports